export default __webpack_public_path__ + "static/media/NetflixLogo.cca6b5ba.png";